
import Button from '../../../components/form-control/Button';
import Input from '../../../components/form-control/Input';
import * as Yup from 'yup';
import { Formik } from 'formik';
import {
  getSinglePremiumFinancingByApplicationNumber,
  getCompaniesByType,
  searchVehicleMake,
  searchVehicleModelsByMake,
  updatePremiumFinancingApplication} from '../../../api/requests';

import {
  getFormattedPhoneNumber,
  getFormattedSentence,
  getListFromEnum,
  getPhoneNumberFromShortCodeFormat,
  getUnformattedSentence,
  sentenceCase,
  showToast
} from '../../../utils/miscFunctions';
import { useEffect, useState } from 'react';
import { GENDER, PREMIUM_FINANCING_VEHICLES_PROTECTION_TYPES, POLICY_DOCUMENT_TYPES, COMPANY_TYPES, UPLOAD_IMAGE_ENDPOINTS, UPLOADABLE_DOCUMENT_TYPES, SOCIAL_MEDIA_PLATFORMS } from '../../../resources/enums';
import { useSelector } from 'react-redux';
import { getSelectedCountry } from '../../../states/slices/resourceSlice';
import moment from 'moment';
import SelectMenu, { ISelectMenuItemValue } from '../../../components/form-control/SelectMenu';
import { ALPHABETS, ID_NUMBER_ERROR_MESSAGE, ID_NUMBER_PATTERNS, REGIONS_BY_COUNTRY, VEHICLE_COLORS } from '../../../resources/constants';
import { IMultiSelectItem, MultiSelect } from '../../../components/form-control/MultiSelect';
import InputSelectMenu from '../../../components/form-control/InputSelectMenu';
import { startCase } from 'lodash';
import { useNavigate, useParams } from 'react-router-dom';
import Loader from '../../../components/Loader';
import { useQuery, useQueryClient } from '@tanstack/react-query';
import useRoute from '../../../hooks/routesHook';
import BackButton from '../../../components/BackButton';
import FileUpload from '../../../components/elements/FileUpload/FileUpload';
import { IPolicyDocument, IPremiumFinancingDTO } from '../../../resources/interfaces';
import useUserAccount from '../../../hooks/userAccountHook';
import { subYears } from 'date-fns';
import useImage from '../../../hooks/imageHook';

interface IApplicationDocumentFiles {
  card: File | null;
  passport: File | null;
  license: File | null;
  roadWorthy: File | null;
}
interface IOwnerApplicationDocumentFiles {
  card: File | null;
  passport: File | null;
  license: File | null;
  roadWorthy: File | null;
}
const PremiumFinancingEdit = () => {

  const [loading, setLoading] = useState<boolean>(true);
  const [error, setError] = useState<boolean>(false);
  
  
  const GenderList = Object.values(GENDER).map((value) => startCase(value));
  const PROTECTION_TYPES = Object.values(PREMIUM_FINANCING_VEHICLES_PROTECTION_TYPES).map((value) => getFormattedSentence(value));
  const [selectedVehicleMake, setSelectedVehicleMake] = useState<string>("");
  const [vehicleMakes, setVehicleMakes] = useState<any>([]);
  const [vehicleMakePrefix, setVehicleMakePrefix] = useState<string>("");
  const [loadingMakes, setLoadingMakes] = useState<boolean>(false);
  const [vehicleModels, setVehicleModels] = useState<any>([]);
  const [financingApplication, sefinancingApllication] = useState<any>([]);
  const param = useParams()
  const selectedCountry = useSelector(getSelectedCountry);
  const countryId = selectedCountry?.id ?? 1
  const { user } = useUserAccount();
  const navigate = useNavigate();
  const { getDashboardBase } = useRoute();
  const [teamList, setTeamList] = useState<any[]>([])
  const { uploadPolicyOwnerDocument } = useImage();
  const [applicationDocumentFiles, setApplicationDocumentFiles] = useState<IApplicationDocumentFiles>({
    card: null,
    passport: null,
    license: null,
    roadWorthy: null,
  });


  useEffect(() => {
    if (selectedVehicleMake) {
      setVehicleModels([]);
      seachForVehicleModel();
    }
  }, [selectedVehicleMake]);

  useEffect(() => {
    setLoadingMakes(true);
    seachForVehicleMake();
  }, [vehicleMakePrefix]);

  const seachForVehicleModel = async () => {
    try {
      if (selectedVehicleMake) {
        let models = await searchVehicleModelsByMake(selectedVehicleMake?.toUpperCase()?.trim());
        if (models?.data) {
          setVehicleModels(models?.data);
        }
      }
    }
    catch (error) {
      console.log(error);
    }
  };

  const seachForVehicleMake = async () => {
    try {
      let makes = await searchVehicleMake(vehicleMakePrefix?.toUpperCase());
      if (makes) {
        setVehicleMakes(makes?.data?.splice(0, 100));
        setTimeout(() => {
          setLoadingMakes(false);
        }, 3000);
      }
    }
    catch (error) {
      console.log(error);
    }
  };

  const getPremiumFinancing = async () => {

    await getSinglePremiumFinancingByApplicationNumber(String(param.id))
      .then((res: any) => {
        sefinancingApllication(res.data)
      })
      .catch((error: Error) => {
        console.log("error", error)
        setError(true)
      })
      .finally(() => {

        setLoading(false)

      })
  }

  const getTeams = async () => {
    user?.company?.type && await getCompaniesByType(COMPANY_TYPES.FINANCIER)
      .then(() => {
        
      })
      .catch((error: Error) => {
        console.log("error", error)
      })
  }

  const getIdCard = (): IPolicyDocument | undefined => {
    return financingApplication?.documents?.find(
      (document: IPolicyDocument) =>
        document.docType === POLICY_DOCUMENT_TYPES.ID_CARD
    );
  }

  const getPassport = (): IPolicyDocument | undefined => {
    return financingApplication?.documents?.find(
      (document: IPolicyDocument) =>
        document.docType === POLICY_DOCUMENT_TYPES.PASSPORT_PHOTO
    );
  }

  const getLicense = (): IPolicyDocument | undefined => {
    return financingApplication?.documents?.find(
      (document: IPolicyDocument) =>
        document.docType === POLICY_DOCUMENT_TYPES.DRIVER_LICENSE_FRONT
    );
  }

  const getRoadWorthy = (): IPolicyDocument | undefined => {
    return financingApplication?.documents?.find(
      (document: IPolicyDocument) =>
        document.docType === POLICY_DOCUMENT_TYPES.ROADWORTHY
    );
  }

  const getPolicyDocumentType = (
    key:
      | 'passport'
      | 'card'
      | 'roadWorthy'
      | 'license'
  ): UPLOADABLE_DOCUMENT_TYPES => {
    switch (key) {
      case 'passport':
        return UPLOADABLE_DOCUMENT_TYPES.PASSPORT_PHOTO;

      case 'card':
        return UPLOADABLE_DOCUMENT_TYPES.ID_CARD;

      case 'roadWorthy':
        return UPLOADABLE_DOCUMENT_TYPES.ROADWORTHY;

      case 'license':
        return UPLOADABLE_DOCUMENT_TYPES.DRIVER_LICENSE_FRONT;

      default:
        return UPLOADABLE_DOCUMENT_TYPES.ID_CARD;
    }
  };

  const uploadImages = () => {
    const url = UPLOAD_IMAGE_ENDPOINTS.DOCUMENT;
    const imageRequests: any[] = [];
    const applicationDocumentRequests: any[] = [];


    Object.keys(applicationDocumentFiles).forEach((key: any) => {
      if (applicationDocumentFiles[key as keyof IOwnerApplicationDocumentFiles]) {
        applicationDocumentRequests.push(
          uploadPolicyOwnerDocument(
            applicationDocumentFiles[key as keyof IOwnerApplicationDocumentFiles] ?? '',
            getPolicyDocumentType(key),
            url,
            financingApplication?.customer?.id ?? ''
          )
        );
      }
    });



    Promise.all([...imageRequests, ...applicationDocumentRequests])
  };

  useQuery({ queryKey: ['getPremiumFinancing'], queryFn: getPremiumFinancing })
  useQuery({ queryKey: ['getTeams', teamList], queryFn: getTeams })

  if(!loading && error) {
    return(
      <div className='text-gray-500 text-2xl h-screen flex items-center justify-center'>
        <span className='text-red-400'>Oups! </span>{" "} 
        An error occurred. Kindly retry later.
      </div>
    )
  }

  return (
    <>
    
    {loading ? 
    <div className='flex items-center justify-center min-h-screen'>
      <Loader  brollyLoaderFixed message='Please, wait while fetching...'/>
    </div>
     :
    financingApplication && financingApplication?.customer && !error && <>
        <div className=' flex gap-5 mb-6 items-center'>
          <div className="w-fit">
            <BackButton
              onClick={() => navigate(`${getDashboardBase()}/premium-financing/${financingApplication?.applicationNumber}`, { replace: true })}
            />
          </div>
          <h2 className='text-4xl font-semibold dark:text-darkBg-mainText'>Application-{financingApplication?.applicationNumber ?? ''}</h2>
        </div>
    
    
    <div className="py-6 px-3 md:px-6 rounded-2xl w-full bg-white dark:!text-darkBg-mainText dark:bg-darkBg dark:border dark:border-darkBg-border">
     
      <Formik
        initialValues={{
              email: financingApplication?.customer?.email ? String(financingApplication?.customer?.email) : '',
              firstName: financingApplication?.customer?.firstName ? String(financingApplication?.customer?.firstName) : '',
              lastName: financingApplication?.customer?.lastName ? String(financingApplication?.customer?.lastName) : '',
              phone: getPhoneNumberFromShortCodeFormat(String(financingApplication?.customer?.phone)),
              countryId: countryId,
              idNumber: financingApplication?.customer?.idNumber ? financingApplication?.customer?.idNumber : '',
              idType: getFormattedSentence(financingApplication?.customer?.idType),
              make: financingApplication?.vehicles?.maker ? financingApplication?.vehicles?.maker : '',
              gender: financingApplication?.customer?.gender == 'OTHERS' || financingApplication?.customer?.gender == 'UNSPECIFIED' ? '' : financingApplication?.customer?.gender,
              chassisNumber: financingApplication?.vehicles?.chassisNumber ? financingApplication?.vehicles?.chassisNumber : '',
              premiumAmount: financingApplication?.premium ? financingApplication?.premium : '',
              model: financingApplication?.vehicles?.model ? financingApplication?.vehicles?.model : '',
              protectionType: financingApplication?.protectionType ? financingApplication?.protectionType : '',
              registrationNumber: financingApplication?.vehicles?.registrationNumber ? financingApplication?.vehicles?.registrationNumber : undefined,
              address: financingApplication?.customer?.address ? String(financingApplication?.customer?.address) : '',
              idExpiryDate: moment(financingApplication?.customer?.idExpiry).format("YYYY-MM-DD"),
              city: financingApplication?.customer?.city ? String(financingApplication?.customer?.city) : undefined,
              state: financingApplication?.customer?.state ? String(financingApplication?.customer?.state) : undefined,
              color: financingApplication?.vehicles?.color ? String(financingApplication?.vehicles?.color) : undefined,
              dateOfBirth: financingApplication?.customer?.dateOfBirth ? moment(financingApplication?.customer?.dateOfBirth).format("YYYY-MM-DD") : undefined,
              digitalAddress: financingApplication?.customer?.digitalAddress ? financingApplication?.customer?.digitalAddress : undefined,
              employerAddress: financingApplication?.customer?.employerAddress ? financingApplication?.customer?.employerAddress : undefined,
              employerName: financingApplication?.customer?.employerName ? financingApplication?.customer?.employerName : undefined,
              employerPhone: financingApplication?.customer?.employerPhone ? financingApplication?.customer?.employerPhone : undefined,
              insurerId: financingApplication?.insurer.id,
              occupation: financingApplication?.customer?.occupation ? financingApplication?.customer?.occupation : undefined,
              planId: financingApplication?.plan.id,
              position: financingApplication?.customer?.position ? financingApplication?.customer?.position : undefined,
              socialPlatform: financingApplication?.customer?.socialPlatform ? financingApplication?.customer?.socialPlatform : undefined,
              socialPlatformIdentifier: financingApplication?.customer?.socialPlatformIdentifier ? financingApplication?.customer?.socialPlatformIdentifier : undefined,
              financierId: 48588,
            }}
            enableReinitialize={true}
            validateOnChange={true}
            validationSchema={Yup.object().shape({
              idNumber: Yup.string()
                .required('Id Number is required')
                .matches(ID_NUMBER_PATTERNS[selectedCountry.iso], ID_NUMBER_ERROR_MESSAGE[selectedCountry.iso]),
              // chassisNumber: Yup.string()
              //   .required('Vin is required.'),
                // .min(17, 'Vin must be 17 characters long')
                // .max(17, 'Vin must be 17 characters long'),
              firstName: Yup.string().required("First name is required"),
              lastName: Yup.string().required("Last name is required"),
              phone: Yup.number().required("Phone number is required"),
              // gender: Yup.string().required("Gender is required"),
              idExpiryDate: Yup.string().required("Expiry date is required"),
              // registrationYear: Yup.string().required("Registration year is required"),
              //premiumAmount: Yup.number().required("Premium is required"),
              // protectionType: Yup.string().required("Protection type is required"),
              address: Yup.string().required("Location is required"),
              email: Yup.string().email("Invalid email address").required("Email is required"),
              // make: Yup.string().required("Make is required"),
              // model: Yup.string().required("Model is required"),
              state: Yup.string().required("State is required"),
              //registrationNumber: Yup.string().required("Registration number is required"),
              //color: Yup.string().required("Color is required"),
              dateOfBirth: Yup.date().required("Date of birth is required").max(subYears(new Date(), 18)),
              digitalAddress: Yup.string().required("Digital address is required"),
              employerAddress: Yup.string().required("Employer address is required"),
              employerName: Yup.string().required("Employer name is required"),
              employerPhone: Yup.string().required("Employer phone is required"),
              //occupation: Yup.string().required("Occupation is required"),
              position: Yup.string().required("Position is required"),
              //socialPlatform: Yup.string().required("Social platform is required"),
              //socialPlatformIdentifier: Yup.string().required("Social platform Username is required"),
              city: Yup.string().required("City is required"),
              // financierId: Yup.string().required("Financier is required"),
            })}
            validateOnBlur={false}
            onSubmit={(values) => {
              const payload: IPremiumFinancingDTO = {
                countryId: countryId,
                firstName: values.firstName,
                lastName: values.lastName,
                phone: values.phone && getFormattedPhoneNumber(values.phone),
                email: values.email,
                idNumber: values.idNumber,
                idType: 'NATIONAL_ID',
                make: values.make ? values.make : null,
                gender: values.gender,
                chassisNumber: values.chassisNumber ? values.chassisNumber : null,
                premiumAmount: values.premiumAmount,
                model: values.model ? values.model : null,
                protectionType: values.protectionType ? getUnformattedSentence(values.protectionType) : null,
                registrationNumber: values.registrationNumber,
                address: values.address,
                idExpiryDate: moment(values.idExpiryDate).format("YYYY-MM-DD"),
                city: values.city,
                state: values.state,
                color: values.color,
                dateOfBirth: moment(values.dateOfBirth).format("YYYY-MM-DD"),
                digitalAddress: values.digitalAddress,
                employerAddress: values.employerAddress,
                employerName: values.employerName,
                employerPhone: values.employerPhone,
                insurerId: values.insurerId,
                occupation: values.occupation,
                planId: values.planId,
                position: values.position,
                socialPlatform: values.socialPlatform ? values.socialPlatform : null,
                socialPlatformIdentifier: values.socialPlatformIdentifier ? values.socialPlatformIdentifier : null,
                financierId: values.financierId
              };

              const applicationNumber = financingApplication?.applicationNumber;
              const id = financingApplication?.id;


              updatePremiumFinancingApplication(id, payload)
                .then(() => {
                  uploadImages()
                  showToast.success('Application Saved successfully.');
                  navigate(`${getDashboardBase()}/premium-financing/${applicationNumber}`, { replace: true })
                })
                .catch((error: any) => {
                  showToast.error(error.description && 'Something went wrong');
                })
                .finally(() => {
                  
                });
            }}>
            {({
              values,
              errors,
              handleSubmit,
              handleChange,
              handleBlur,
              setFieldValue,
              touched
            }) => (
              <form className="" onSubmit={handleSubmit}>

                <div className='flex gap-4 justify-between '>
                  {/* CONTACT FORM */}
                  <div className="w-full rounded-2xl border-[1px] border-gray-300 dark:border-darkBg-border p-4">
                    <h2 className="text-xl font-semibold pb-5">Applicant Information</h2>
                    <div className="grid grid-cols-2 gap-5">
                      <Input
                        type={'text'}
                        name="firstName"
                        value={values.firstName}
                        onChange={handleChange}
                        onBlur={handleBlur}
                        label="First Name"
                        error={touched.firstName ? errors.firstName : undefined}
                        helperText={touched?.firstName ? errors.firstName : undefined}
                        className="rounded"
                      />

                      <Input
                        type={'text'}
                        name="lastName"
                        value={values.lastName}
                        onChange={handleChange}
                        onBlur={handleBlur}
                        label="Last Name"
                        error={touched.lastName ? errors.lastName : undefined}
                        helperText={touched?.lastName ? errors.lastName : undefined}
                        className="rounded"
                      />

                      <Input
                        type={'email'}
                        name="email"
                        value={values.email}
                        onChange={handleChange}
                        onBlur={handleBlur}
                        label="Email"
                        required
                        error={touched.email ? errors.email : undefined}
                        helperText={touched?.email ? errors.email : undefined}
                        className="rounded"
                      />

                      <Input
                        type={'text'}
                        name="phone"
                        value={values.phone}
                        onChange={handleChange}
                        onBlur={handleBlur}
                        label="Phone Number"
                        error={touched.phone ? errors.phone : undefined}
                        helperText={touched?.phone ? errors.phone : undefined}
                        className="rounded"
                      />

                      <Input
                        type={'date'}
                        name="dateOfBirth"
                        value={values.dateOfBirth}
                        onChange={handleChange}
                        onBlur={handleBlur}
                        label="Date Of Birth"
                        error={touched.dateOfBirth ? errors.dateOfBirth : undefined}
                        helperText={touched?.dateOfBirth ? errors.dateOfBirth : undefined}
                        className="rounded"
                      />

                      <SelectMenu
                        label="Gender"
                        name="gender"
                        listSelectedValue={values.gender}
                        onChange={(val: ISelectMenuItemValue | null) => {
                          setFieldValue('gender', val);
                        }}
                        onBlur={handleBlur}
                        searchPlaceHolder="Search a gender..."
                        list={GenderList}
                        placeholder="Select a gender"
                        // required
                        error={touched.gender ? errors.gender : undefined}
                        helperText={touched?.gender ? errors.gender : undefined}
                      />

                      <Input
                        type={'text'}
                        name="address"
                        value={values.address}
                        onChange={handleChange}
                        onBlur={handleBlur}
                        label="Address"
                        required
                        placeholder='Enter an address'
                        error={touched.address ? errors.address : undefined}
                        helperText={touched?.address ? errors.address : undefined}
                      />

                      <Input
                        type={'text'}
                        name="city"
                        value={values.city}
                        onChange={handleChange}
                        onBlur={handleBlur}
                        label="City"
                        error={touched.city ? errors.city : undefined}
                        helperText={touched?.city ? errors.city : undefined}
                        className="rounded"
                      />

                      <Input
                        type={'text'}
                        name="digitalAddress"
                        value={values.digitalAddress}
                        onChange={handleChange}
                        onBlur={handleBlur}
                        label="Digital Address"
                        error={touched.digitalAddress ? errors.digitalAddress : undefined}
                        helperText={touched?.digitalAddress ? errors.digitalAddress : undefined}
                        className="rounded"
                      />

                      <Input
                        type={'text'}
                        name="occupation"
                        value={values.occupation}
                        onChange={handleChange}
                        onBlur={handleBlur}
                        label="Occupation"
                        error={touched.occupation ? errors.occupation : undefined}
                        helperText={touched?.occupation ? errors.occupation : undefined}
                        className="rounded"
                      />

                      <Input
                        type={'text'}
                        name="position"
                        value={values.position}
                        onChange={handleChange}
                        onBlur={handleBlur}
                        label="Position"
                        error={touched.position ? errors.position : undefined}
                        helperText={touched?.position ? errors.position : undefined}
                        className="rounded"
                      />



                      {/* <SelectDropdown
                        label="Financier"
                        name="financierId"
                        listSelectedValue={values.financierId}
                        onChange={(val: ISelectDropdownItem | null) => {
                          setFieldValue('financierId', val);
                        }}
                        list={teamList.map(
                          (source: any) =>
                          ({
                            name: source.name,
                            value: source.id
                          } as ISelectDropdownItem)
                        )}
                      required
                      error={touched.financierId ? errors.financierId : undefined}
                      helperText={touched?.financierId ? errors.financierId : undefined}
                      placeholder="Select Financier"
                    />
                   */}

                      <Input
                        type={'text'}
                        name="employerName"
                        value={values.employerName}
                        onChange={handleChange}
                        onBlur={handleBlur}
                        label="Employer Name"
                        error={touched.employerName ? errors.employerName : undefined}
                        helperText={touched?.employerName ? errors.employerName : undefined}
                        className="rounded"
                      />

                      <Input
                        type={'text'}
                        name="employerAddress"
                        value={values.employerAddress}
                        onChange={handleChange}
                        onBlur={handleBlur}
                        label="Employer Address"
                        required
                        placeholder='Enter an address'
                        error={touched.employerAddress ? errors.employerAddress : undefined}
                        helperText={touched?.employerAddress ? errors.employerAddress : undefined}
                      />

                      <Input
                        type={'text'}
                        name="employerPhone"
                        value={values.employerPhone}
                        onChange={handleChange}
                        onBlur={handleBlur}
                        label="Employer Phone"
                        error={touched.employerPhone ? errors.employerPhone : undefined}
                        helperText={touched?.employerPhone ? errors.employerPhone : undefined}
                        className="rounded"
                      />

                      <SelectMenu
                        label="Region"
                        name="state"
                        listSelectedValue={sentenceCase(values?.state ?? '')}
                        onChange={(val: ISelectMenuItemValue | null) => {
                          setFieldValue('state', val);
                        }}
                        onBlur={handleBlur}
                        search
                        searchPlaceHolder="Search by state ..."
                        list={REGIONS_BY_COUNTRY[selectedCountry.iso]}
                        placeholder="Select region"
                        error={touched.state ? errors.state : undefined}
                        helperText={touched?.state ? errors.state : undefined}
                        required
                      />


                      <Input
                        type={'text'}
                        name="idType"
                        value={values.idType}
                        onChange={handleChange}
                        onBlur={handleBlur}
                        label="Id Type"
                        error={touched.idType ? errors.idType : undefined}
                        helperText={touched?.idType ? errors.idType : undefined}
                        className="rounded"
                        disabled
                      />

                      <Input
                        type={'text'}
                        name="idNumber"
                        value={values.idNumber}
                        onChange={handleChange}
                        onBlur={handleBlur}
                        label="Id Number"
                        required
                        error={touched.idNumber ? errors.idNumber : undefined}
                        helperText={touched?.idNumber ? errors.idNumber : undefined}
                        className="rounded"
                      />


                      <Input
                        type={'date'}
                        name="idExpiryDate"
                        value={values.idExpiryDate}
                        onChange={handleChange}
                        onBlur={handleBlur}
                        label="Id Expiry Date"
                        error={touched.idExpiryDate ? errors.idExpiryDate : undefined}
                        helperText={touched?.idExpiryDate ? errors.idExpiryDate : undefined}
                        className="rounded"
                      />


                    </div>
                  </div>

                </div>

                {/* VEHICLE FORM */}
                <div className="w-full rounded-2xl border-[1px] border-gray-300 p-4 mt-5 hidden">
                  <h2 className="text-xl font-semibold pb-5">Vehicle Information</h2>
                  <div className="grid grid-cols-2 gap-5">
                    <MultiSelect
                      label="Vehicle Make"
                      selected={[values.make]}
                      onChange={(val: string[]) => {
                        setFieldValue("make", val?.[0]);
                        if (val && val.length > 0) {
                          setSelectedVehicleMake(val[0]);
                        }
                      }}
                      list={vehicleMakes?.map(
                        (make: any) =>
                        ({
                          name: make,
                          value: make,
                        } as IMultiSelectItem)
                      )}
                      placeholder="Search and select your vehicle make"
                      selectInputClassName='!shadow-none'
                      // error={touched.make ? errors.make : ''}
                      // helperText={touched.make ? errors.make : ''}
                      required
                      description="vehicle make - manufacturer"
                      onQueryChange={(query: string) => { setVehicleMakePrefix(query) }}
                      multiSelect={false}
                      loading={loadingMakes}
                    />

                    <InputSelectMenu
                      label="Vehicle Model"
                      placeholder="Select your vehicle model"
                      description="vehicle model - type"
                      list={vehicleModels}
                      listSelectedValue={values.model}
                      onChange={(val: string) => {
                        setFieldValue("model", val);
                      }}
                      error={touched.model ? errors.model : undefined}
                      helperText={touched.model ? errors.model : undefined}
                      required
                      search
                      searchPlaceHolder="Enter your vehicle model. Eg. Yaris"

                      sort name={''}
                    />



                    <SelectMenu
                      label="Protection Type"
                      name="protectionType"
                      listSelectedValue={getFormattedSentence(values.protectionType)}
                      onChange={(val: ISelectMenuItemValue | null) => {
                        setFieldValue('protectionType', val);
                      }}
                      onBlur={handleBlur}
                      searchPlaceHolder="Search by protection type ..."
                      list={PROTECTION_TYPES}
                      placeholder="Select protection type"
                      required
                      error={touched.protectionType ? errors.protectionType : undefined}
                      helperText={touched?.protectionType ? errors.protectionType : undefined}
                    />

                    {/* <Input
                      type={'text'}
                      name="registrationNumber"
                      value={values.registrationNumber}
                      onChange={handleChange}
                      onBlur={handleBlur}
                      label="Registration Number"
                      required
                      error={touched.registrationNumber ? errors.registrationNumber : undefined}
                      helperText={touched?.registrationNumber ? errors.registrationNumber : undefined}
                      className="rounded"
                    /> */}
                    <Input
                      description={''}
                      type="text"
                      id="registrationNumber"
                      label="Registration Number"
                      className="rounded-[0px] placeholder-[#848484] focus:ring-primary-border px-3"
                      wrapperClasses="pr-0"
                      value={values?.registrationNumber?.toUpperCase()}
                      onChange={handleChange}
                      onBlur={handleBlur}
                      error={touched?.registrationNumber ? errors.registrationNumber : undefined}
                      helperText={touched?.registrationNumber ? errors.registrationNumber : undefined}
                      required
                    />

                    <InputSelectMenu
                      label="Vehicle Color"
                      name="color"
                      listSelectedValue={values.color}
                      onChange={(val: ISelectMenuItemValue | null) => {
                        setFieldValue('color', val);
                      }}
                      onBlur={handleBlur}
                      search
                      list={VEHICLE_COLORS}
                      placeholder="Select vehicle color"
                      error={touched.color ? errors.color : undefined}
                      helperText={touched?.color ? errors.color : undefined}
                      required
                    />

                    <Input
                      type={'text'}
                      name="chassisNumber"
                      value={values.chassisNumber}
                      onChange={handleChange}
                      onBlur={handleBlur}
                      label="Chassis number"
                      required
                      error={touched.chassisNumber ? errors.chassisNumber : undefined}
                      helperText={touched?.chassisNumber ? errors.chassisNumber : undefined}
                      className="rounded"
                    />

                    <Input
                      type={'text'}
                      name="premiumAmount"
                      value={values.premiumAmount}
                      onChange={handleChange}
                      onBlur={handleBlur}
                      label="Premium"
                      required
                      disabled
                      error={touched.premiumAmount ? errors.premiumAmount : undefined}
                      helperText={touched?.premiumAmount ? errors.premiumAmount : undefined}
                      className="rounded"
                    />


                  </div>
                </div>
                <div className="space-y-8 border border-gray-200 dark:border-darkBg-border rounded-2xl mt-5 p-4">
                  <p className="font-semibold text-lg">Documents</p>
                  <div className="space-y-8 md:space-y-0 md:grid md:grid-cols-2 md:gap-4 lg:grid-cols-4">
                    <FileUpload
                      onFileLoad={(images: any) => {
                        if (images && images[0]) {
                          setApplicationDocumentFiles({
                            ...applicationDocumentFiles,
                            card: images[0]
                          });
                        }
                      }}
                      label="Ghana Card"
                      maxHeight={177}
                      maxWidth={350}
                      imageContainerWidth="100%"
                      cropImage={false}
                      defaultImage={getIdCard()}
                      onFileDeleted={() => {
                        setApplicationDocumentFiles({
                          ...applicationDocumentFiles,
                          card: null
                        });
                      }}
                      showFileMax={false}
                      savedImage={
                        financingApplication?.documents?.find(
                          (document: IPolicyDocument) =>
                            document?.docType === POLICY_DOCUMENT_TYPES.ID_CARD
                        )?.docUrl
                      }
                    />

                    <FileUpload
                      onFileLoad={(images: any) => {
                        if (images && images[0]) {
                          setApplicationDocumentFiles({
                            ...applicationDocumentFiles,
                            passport: images[0]
                          });
                        }
                      }}
                      label="Passport Photo"
                      maxHeight={177}
                      maxWidth={350}
                      imageContainerWidth="100%"
                      cropImage={false}
                      defaultImage={getPassport()}
                      onFileDeleted={() => {
                        setApplicationDocumentFiles({
                          ...applicationDocumentFiles,
                          passport: null
                        });
                      }}
                      showFileMax={false}
                      savedImage={
                        financingApplication?.documents?.find(
                          (document: IPolicyDocument) =>
                            document?.docType === POLICY_DOCUMENT_TYPES.PASSPORT_PHOTO
                        )?.docUrl
                      }
                    />

                    <FileUpload
                      onFileLoad={(images: any) => {
                        if (images && images[0]) {
                          setApplicationDocumentFiles({
                            ...applicationDocumentFiles,
                            license: images[0]
                          });
                        }
                      }}
                      label="Driver's License"
                      maxHeight={177}
                      maxWidth={350}
                      imageContainerWidth="100%"
                      cropImage={false}
                      defaultImage={getLicense()}
                      onFileDeleted={() => {
                        setApplicationDocumentFiles({
                          ...applicationDocumentFiles,
                          license: null
                        });
                      }}
                      showFileMax={false}
                      savedImage={
                        financingApplication?.documents?.find(
                          (document: IPolicyDocument) =>
                            document?.docType === POLICY_DOCUMENT_TYPES.DRIVER_LICENSE_FRONT
                        )?.docUrl
                      }
                    />

                    <FileUpload
                      onFileLoad={(images: any) => {
                        if (images && images[0]) {
                          setApplicationDocumentFiles({
                            ...applicationDocumentFiles,
                            roadWorthy: images[0]
                          });
                        }
                      }}
                      label="Road Worthy"
                      maxHeight={177}
                      maxWidth={350}
                      imageContainerWidth="100%"
                      cropImage={false}
                      defaultImage={getRoadWorthy()}
                      onFileDeleted={() => {
                        setApplicationDocumentFiles({
                          ...applicationDocumentFiles,
                          roadWorthy: null
                        });
                      }}
                      showFileMax={false}
                      savedImage={
                        financingApplication?.documents?.find(
                          (document: IPolicyDocument) =>
                            document?.docType === POLICY_DOCUMENT_TYPES.ROADWORTHY
                        )?.docUrl
                      }
                    />
                  </div>
                </div>


                <div className="flex items-end justify-end gap-5   p-4">


                  <div className="">
                    <Button
                      label="Submit"
                      className="w-fit px-[20px]  rounded border border-primary-border  bg-primary-main "
                      onClick={handleSubmit}
                      disabled={loading}
                      loading={loading}
                      curved
                      bgColor="primary"
                    />
                  </div>
                </div>
              </form>
            )}
          </Formik>
        </div>
        </>}
        
    </>
  );
  
}

export default PremiumFinancingEdit
